<template>
  <div class="bg-card wow fadeInDown">
    <div class="zy-container">
      <div class="func-title text-center">智莺 <span style="color: #353FDC">“直播电商”</span> 超强能力库</div>
      <div class="library-bar">
        <div class="library-col" v-for="(library,index) in libraryData" :key="index">
          <div class="library-feature">
            <el-image :src="library.img" class="lib-img"></el-image>
            <div class="desc">{{ library.text }}</div>
            <div class="desc">{{ library.text1 }}</div>
          </div>
        </div>
      </div>
      <div class="open-btn" @click="login">开启你专属的直播间</div>
    </div>
  </div>
</template>

<script>
import {WOW} from "wowjs";
export default {
  name: "func-library",
  data() {
    return {
      libraryData: [
        {
          img: require('@/assets/images/index/live-video/library1.png'),
          text: '连接数十亿流量',
          text1: '更多平台更多订单'
        },
        {
          img: require('@/assets/images/index/live-video/library2.png'),
          text: '购买无需跳转',
          text1: '加速意向成单'
        },
        {
          img: require('@/assets/images/index/live-video/library3.png'),
          text: '多种直播间互动玩法',
          text1: '人气、粉丝尽收囊中'
        },
        {
          img: require('@/assets/images/index/live-video/library4.png'),
          text: '高清回放保存',
          text1: '全面直播复盘'
        },
        {
          img: require('@/assets/images/index/live-video/library5.png'),
          text: '清晰数据播报',
          text1: '业绩订单一目了然'
        },
        {
          img: require('@/assets/images/index/live-video/library6.png'),
          text: '多样化页面需求',
          text1: '满足个性化需求'
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  methods: {
    login() {
      this.$router.push("/login");
    }
  }
}
</script>

<style scoped lang="scss">

.bg-card {
  background: #F8F8FC;
  padding-bottom: 55px;
  padding-top: 80px;
}

.func-title {
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  padding-bottom: 70px;
}

.library-bar {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;

  .library-col {
    background: #FFFFFF;
    border-radius: 24px;
    padding-top: 10px;
    padding-bottom: 20px;
    transition: all .3s cubic-bezier(0, 0, .5, 1);

    .library-feature {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }

    .desc {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      letter-spacing: 1px;
    }

    .lib-img {
      width: 96px;
      height: 96px;
    }
  }

  .library-col:hover {
    box-shadow: 2px 4px 16px rgba(0, 0, 0, .16);
    transform: scale3d(1.01, 1.01, 1.01)
  }
}

.open-btn {
  width: 200px;
  border-radius: 6px;
  background-image: linear-gradient(180deg, #404DFF 0%, #918BFF 100%);
  margin: 30px auto 0;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  color: #FFFFFF;
  cursor: pointer;
}
</style>
